import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import images from '@assets/images-base';
import BreadCrumb, { IBread } from '@components/Breadcrumb/BreadCrumb';

import { IDirectDebitSubCompany, IFile } from 'constants/operatorSite';
import { Tooltip } from 'antd';
import { IconFile } from '@components/Icon';
import { FileItem } from './FileItem/FileItem';
import { COMPANY_STATUS, STATUS_COMPANY } from 'constants/company';
import {
  IDefaultFile,
  IDetailCompany,
  IDocumentCompany,
} from '@pages/OperatorSite/Companies/ListCompany/useListCompany';
import { stringToPhoneView } from 'helper/formatPhone';
import { CONST_LIST_AGENCY } from '@pages/OperatorSite/Agencies/ListAgency/constants';
import { formatDateJP, formatStrDateTimezone } from 'helper/date';
import { CompanyCard, Container } from '@pages/OperatorSite/Companies/CreateCompany/createCompanyStyle';
import { DebitCardItem, TitleWrapper, WrapperFile, DirectDebitSubCompanyWrapper } from '@containers/CompanySite/GrantCompany/CompanyStyle';
import { NameWrapper, StatusUpdate } from '@containers/OperatorSite/Agency/DetailAgency/detailAgencyStyle';
import { CardItem, CardItemFullWidth, RowCenter, SpaceBase } from 'styles';
import { CONST_BREADS, CONST_COMPANY_DEBIT, CONST_CREATE_COMPANY, CONST_LIST_COMPANY } from 'constants/language';
import {
  EStatusCompany,
  EStatusFile,
  EStatusFileConfirm,
  OPTION_ADD,
  SettingRegulationsEnum,
  USAGE_PLAN,
} from 'constants/constants';
import {
  BtnFileCompanyVerificationWrapper,
  CompanyNameDetail,
  DeleteDetailBtn,
  TitleDetailCompanyWrapper,
  UnderView,
  DirectDebitItemWrapper,
} from './detailCompanyStyle';

import {
  DetailOperatorWrapper,
  ElementCard,
} from '@containers/OperatorSite/Operator/DetailOperator/detailOperatorStyle';
import {
  BtnSubmitFile,
  BtnVerification,
  BtnVerificationWrapper,
  ErrorOperator,
} from '@pages/OperatorSite/Operators/CreateOperator/createOperatorStyle';
import DefaultFileItem from './DefaultFileItem/DefaultFileItem';
import { apiGetLastAgreedRegulations } from 'api';
import { responseSuccess } from 'helper/responseSuccess/responseSuccess';
import dayjs from 'dayjs';
import { WrapperList, WrapperOption } from '@containers/CompanySite/GrantCompany/ConfirmCreate';
import styled from 'styled-components';

const BREADS: IBread[] = [
  {
    name: CONST_BREADS.LIST_COMPANY,
    path: '',
  },
];

const ElementCardDate = styled.div`
  width: 67.875rem;
  display: flex;
  flex-direction: row;
  font-size: 1.25rem;
  padding-right: 1rem;
  padding-top: 0.313rem;
  word-break: break-all;
  margin-left: 7px;
  .space {
    margin: 0 14px;
  }
`;


export const DetailCompany = ({
  company,
  documentsDefault,
  setIsEdit,
  onDeleteCompany,
  onConfirmOperatorDocument,
  isLoadingOperatorConfirmDocument,
}: {
  company: IDetailCompany | null;
  isLoadingOperatorConfirmDocument: boolean;
  documentsDefault: IDefaultFile[];
  setIsEdit: (isEdit: boolean) => void;
  onDeleteCompany: () => void;
  onConfirmOperatorDocument: (data: any) => void;
}) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const [documents, setDocuments] = useState<IDocumentCompany[] | IFile[]>();
  const [isShowBtnApprove, setIsChowBtnApprove] = useState<boolean>(false);
  const [isDisableApprove, setIsDisableApprove] = useState<boolean>(true);
  const [isShowBtnReject, setIsChowBtnReject] = useState<boolean>(false);
  const [isDisableReject, setDisableReject] = useState<boolean>(true);

  const [statusConfirm, setStatusConfirm] = useState<number>();
  const [textApprove, setTextApprove] = useState<string>(CONST_LIST_COMPANY.BTN_ROLLBACK_ACCOUNT);
  const [lastAgreedRegulations, setLastAgreedRegulations] = useState<string>();

  const getLastAgreedRegulations = useCallback(async () => {
    if (company?.id) {
      const response = await apiGetLastAgreedRegulations(SettingRegulationsEnum.TYPE_OPERATOR_COMPANY, company?.id);
      if (responseSuccess(response)) {
        setLastAgreedRegulations(response?.data?.regulations);
      }
    }
  }, [company?.id]);

  useEffect(() => {
    if (company?.documents) {
      setDocuments(company.documents);
      getLastAgreedRegulations();
    } else {
      setDocuments([]);
    }
    return () => {
      setDocuments([]);
      setTextApprove(CONST_LIST_COMPANY.BTN_ROLLBACK_ACCOUNT);
    };
  }, [company, getLastAgreedRegulations]);

  useEffect(() => {
    if (documents) {
      const _documents = [...documents];
      let statusArr: number[] = [];
      _documents.forEach((item: IDocumentCompany) => {
        if (item?.status) {
          statusArr = [...statusArr, item.status];
        }
      });
      if (
        (statusArr.includes(EStatusFile.UN_TICKED) ||
          statusArr.includes(EStatusFile.REJECT_DRAFT) ||
          statusArr.includes(EStatusFile.TICKED_DRAFT) ||
          statusArr.includes(EStatusFile.REJECT)) &&
        company?.status !== EStatusCompany.STATUS_REJECT
      ) {
        setIsChowBtnApprove(true);
      } else {
        setIsChowBtnApprove(false);
      }
      if (statusArr.includes(EStatusFile.REJECT_DRAFT)) {
        setIsChowBtnReject(true);
      } else {
        setIsChowBtnReject(false);
      }

      if (statusArr?.length) {
        const _statusArr = Array.from(new Set(statusArr));
        if (
          _statusArr.length === 1 &&
          (_statusArr[0] === EStatusFile.TICKED || _statusArr[0] === EStatusFile.TICKED_DRAFT)
        ) {
          setTextApprove(CONST_LIST_COMPANY.BTN_APPROVED_DUCUMENT);
        }
      }
      if (statusArr.includes(EStatusFile.REJECT_DRAFT)) {
        setTextApprove(CONST_LIST_COMPANY.BTN_ROLLBACK_ACCOUNT);
      }
      if (statusArr.includes(EStatusFile.REJECT)) {
        setTextApprove(CONST_LIST_COMPANY.RE_REQUESTING);
      }

      if (statusArr.includes(EStatusFile.UN_TICKED)) {
        setIsDisableApprove(true);
        setTextApprove(CONST_LIST_COMPANY.BTN_APPROVED_DUCUMENT);
        setDisableReject(true);
      } else {
        setIsDisableApprove(statusArr.includes(EStatusFile.REJECT) ? true : false);
        setDisableReject(false);
      }
    }
  }, [company?.status, documents]);

  const confirmOperatorDocument = (status: number) => {
    setStatusConfirm(status);
    onConfirmOperatorDocument({
      company_id: company?.id,
      user_id: company?.user_root.id,
      status: status,
      documents,
    });
  };

  const updateDocument = (document: IDocumentCompany) => {
    if (documents) {
      const _documents = documents.map((item: IDocumentCompany) => {
        if (document.id === item.id) {
          return { ...item, status: document.status, note: document.note };
        }
        return { ...item };
      });

      setDocuments(_documents);
    }
  };

  const onClickEdit = () => {
    if (company) {
      setIsEdit(true);
      navigate({
        pathname: `/company/edit/${btoa(company.id.toString())}`,
        search,
      });
    }
  };

  return (
    <DetailOperatorWrapper>
      <BreadCrumb breads={BREADS} />
      {company && (
        <Container>
          <CompanyCard>
            <div>
              <TitleDetailCompanyWrapper>
                <SpaceBase width={1} />
                <img src={images.sideBar.agencySidebar} alt="" />
                <Tooltip placement="bottomLeft" title={company.name}>
                  <RowCenter>
                    <CompanyNameDetail>{company.name}</CompanyNameDetail>
                    {company.status === EStatusCompany.STATUS_NOTVNVERIFY && <UnderView>{'審査中'}</UnderView>}
                  </RowCenter>
                </Tooltip>
              </TitleDetailCompanyWrapper>

              <SpaceBase height={1} />

              <CardItem lineBottom={true} paddingHoz="0.625rem 0">
                <div>{CONST_LIST_COMPANY.COMPANY_NAME}</div>
                <ElementCard>{company.name}</ElementCard>
                <ElementCard width="17rem">{CONST_LIST_COMPANY.COMPANY_CODE}</ElementCard>
                <ElementCard>{company.code}</ElementCard>
              </CardItem>

              <CardItem paddingHoz="0.625rem 0">
                <div>{CONST_CREATE_COMPANY.POSTAL_CODE}</div>
                <ElementCard>
                  {company?.postal_code && (
                    <>
                      {company.postal_code?.slice(0, 3)} - {company.postal_code?.slice(3, 7)}
                    </>
                  )}
                </ElementCard>
              </CardItem>

              <CardItem paddingHoz="0.75rem 0">
                <div>{CONST_CREATE_COMPANY.ADDRESS_FIRST}</div>
                <ElementCard>{company.address1}</ElementCard>
                <ElementCard width="17rem">{CONST_CREATE_COMPANY.ADDRESS_SECOND}</ElementCard>
                <ElementCard>{company.address2}</ElementCard>
              </CardItem>

              <CardItem lineBottom={true} paddingHoz="0.625rem 0">
                <div>{CONST_LIST_COMPANY.REPRESENTATIVE_NAME}</div>
                <ElementCard>{company?.user_root?.full_name}</ElementCard>
                <ElementCard width="17rem">{CONST_CREATE_COMPANY.OPERATOR_ID}</ElementCard>
                <ElementCard>{company?.user_root?.code}</ElementCard>
              </CardItem>

              <CardItem lineBottom={true} paddingHoz="0.625rem 0">
                <div>{CONST_CREATE_COMPANY.FEE_FREE_DATE}</div>
                <ElementCardDate>
                  {company?.free_start_date ? formatDateJP(dayjs(company.free_start_date).format('YYYY-MM-DD')) : ''}
                  <span className="space">{(company?.free_start_date || company?.free_end_date) && '〜'}</span>
                  {company?.free_end_date ? formatDateJP(dayjs(company.free_end_date).format('YYYY-MM-DD')) : ''}
                </ElementCardDate>
              </CardItem>

              <CardItem lineBottom={true} paddingHoz="0.625rem 0">
                <div>{CONST_LIST_COMPANY.PHONE_NUMBER}</div>
                <ElementCard>{stringToPhoneView(company?.user_root?.phone)}</ElementCard>
                <ElementCard width="17rem">{CONST_LIST_COMPANY.EMAIL_ADDRESS}</ElementCard>
                <ElementCard>{company?.user_root?.email}</ElementCard>
              </CardItem>

              <CardItem lineBottom={true} paddingHoz="0.625rem 0">
                <div>{CONST_CREATE_COMPANY.FEE}</div>
                <ElementCard>
                  {company.fee}
                  <span className='company-fee'>{company.fee ? '円' : ''}</span>
                </ElementCard>
              </CardItem>

              <CardItem lineBottom={true} paddingHoz="0.75rem 0">
                <div>{CONST_CREATE_COMPANY.ADDITION_OPTIONS}</div>
                <WrapperList>
                  {company.company_add_options?.map((option: any, index: number) => {
                    return (
                      <WrapperOption>
                        {OPTION_ADD?.find(opt => opt.value === option.type)?.label}
                        {option?.charge && (
                          <>
                            <span className="company-charge">{option.charge}</span>
                            <span>{'円'}</span>
                          </>
                        )}
                      </WrapperOption>
                    );
                  })}
                </WrapperList>
              </CardItem>

              <CardItem lineBottom={true} paddingHoz="0.625rem 0">
                <div>{CONST_LIST_COMPANY.USAGE_PLAN}</div>
                <ElementCard>{USAGE_PLAN[company.usage_plan - 1].label}</ElementCard>
                <ElementCard width="17rem">{CONST_LIST_COMPANY.REGISTRATION_STATUS}</ElementCard>
                <ElementCard>{COMPANY_STATUS[company?.status || EStatusCompany.STATUS_NOTVNVERIFY]}</ElementCard>
              </CardItem>

              <CardItem paddingHoz="0.625rem 0">
                <div>{CONST_CREATE_COMPANY.AGENCY_CODE}</div>
                <ElementCard>
                  {company?.agency?.name || company?.agency?.user_root?.full_name}
                  {company?.agency?.code && ` (${company?.agency?.code})`}
                </ElementCard>
                <ElementCard width="17rem">{CONST_LIST_COMPANY.AGENCY_FEE}</ElementCard>
                <ElementCard>
                  {company.agency_fee || company.agency_fee === 0
                    ? `${company.agency_fee}${CONST_LIST_COMPANY.YEN}`
                    : ''}
                </ElementCard>
              </CardItem>

              <BtnVerificationWrapper>
                <BtnVerification onClick={() => onClickEdit()}>{CONST_LIST_AGENCY.EDIT}</BtnVerification>
                {company.status === STATUS_COMPANY.status_active ? (
                  <DeleteDetailBtn className="disabled_company_deleted" disabled={true}>
                    {CONST_LIST_AGENCY.DELETE}
                  </DeleteDetailBtn>
                ) : (
                  <DeleteDetailBtn onClick={onDeleteCompany}>{CONST_LIST_AGENCY.DELETE}</DeleteDetailBtn>
                )}
              </BtnVerificationWrapper>

              <SpaceBase height={1} />
              <TitleWrapper>
                <div>{CONST_LIST_COMPANY.DOCUMENTS}</div>
                <div />
              </TitleWrapper>
              <SpaceBase height={1} />

              <CardItemFullWidth lineBottom={true} paddingHoz="0.625rem 0">
                <WrapperFile>
                  <DefaultFileItem
                    documentsDefault={documentsDefault}
                    company={company}
                    documents={documents}
                    lastAgreedRegulations={lastAgreedRegulations}
                  />
                  {documents?.map((element: IFile) => {
                    return (
                      <React.Fragment key={String(element.id)}>
                        <FileItem
                          name={element.name}
                          status={element.status}
                          link={element.link}
                          documentId={element.id}
                          note={element?.note}
                          notShowBtn={!isShowBtnApprove && !isShowBtnReject}
                          onUpdateDocument={updateDocument}
                        />
                      </React.Fragment>
                    );
                  })}
                </WrapperFile>
              </CardItemFullWidth>
              <CardItemFullWidth lineBottom={true} paddingHoz="0.625rem 0">
                {!company?.can_direct_debit ? (
                  <DebitCardItem>
                    <div>{CONST_COMPANY_DEBIT.SETTING_GROUP}</div>
                    <div style={{
                      color: '#ff4d4f',
                      padding: '0.5rem',
                    }}>
                      {CONST_COMPANY_DEBIT.CANNOT_SETTING_DIRECT_DEBIT}
                    </div>
                  </DebitCardItem>
                ) : (
                  <>
                    <DebitCardItem>
                      <div>{CONST_COMPANY_DEBIT.SETTING_GROUP}</div>
                    </DebitCardItem>
                    <DebitCardItem>
                      <div>{CONST_COMPANY_DEBIT.DIRECT_DEBIT_ENABLE}</div>
                      <ElementCard>
                        {company?.direct_debit_enabled ? CONST_COMPANY_DEBIT.ENABLE : CONST_COMPANY_DEBIT.DISABLE}
                      </ElementCard>
                    </DebitCardItem>
                    <DebitCardItem>
                      <div>{CONST_COMPANY_DEBIT.DIRECT_DEBIT_START_MONTH}</div>
                      <ElementCardDate>
                        {company?.direct_debit_start_month ? formatDateJP(dayjs(company.direct_debit_start_month).format('YYYY-MM'), false) : ''}
                      </ElementCardDate>
                    </DebitCardItem>
                    <DebitCardItem>
                      <div>{CONST_COMPANY_DEBIT.CUSTOMER_ID}</div>
                      <ElementCard>{company?.direct_debit_account_number}</ElementCard>
                    </DebitCardItem>
                    <DebitCardItem>
                      <div>{CONST_COMPANY_DEBIT.INVOICE_NUMBER}</div>
                      <ElementCard>{company?.direct_debit_invoice_number}</ElementCard>
                    </DebitCardItem>
                    <DebitCardItem>
                      <div style={{ width: '12rem' }}>{CONST_COMPANY_DEBIT.SUB_COMPANY}</div>
                      <div style={{ width: '100%' }}>
                        <DirectDebitSubCompanyWrapper>
                          {company?.direct_debit_sub_companies?.map((element: IDirectDebitSubCompany, index: number) => (
                            <Tooltip key={index} placement="topLeft" title={element.name}>
                              <div className="sub-company-item">
                                {element.name}
                              </div>
                            </Tooltip>
                          ))}
                        </DirectDebitSubCompanyWrapper>
                      </div>
                    </DebitCardItem>
                  </>
                )}
              </CardItemFullWidth>

            </div>

            <BtnFileCompanyVerificationWrapper>
              {isShowBtnApprove && (
                <BtnSubmitFile
                  disabled={isDisableApprove || isLoadingOperatorConfirmDocument}
                  loading={isLoadingOperatorConfirmDocument && statusConfirm === EStatusFileConfirm.APPROVE}
                  onClick={() => confirmOperatorDocument(EStatusFileConfirm.APPROVE)}
                >
                  <div className="icon rollback">
                    <IconFile width={'3.625rem'} height={'3.625rem'} bgColor={'#B3B3B3'} />
                  </div>
                  {textApprove}
                </BtnSubmitFile>
              )}
              {isShowBtnReject && isShowBtnApprove && <SpaceBase width={6.25} />}
              {isShowBtnReject && (
                <BtnSubmitFile
                  className="reject"
                  onClick={() => confirmOperatorDocument(EStatusFileConfirm.REJECT)}
                  disabled={isDisableReject || isLoadingOperatorConfirmDocument}
                  loading={isLoadingOperatorConfirmDocument && statusConfirm === EStatusFileConfirm.REJECT}
                >
                  <div className="icon">
                    <img src={images.common.iconClose} alt={images.common.iconClose} />
                  </div>
                  {CONST_LIST_COMPANY.BTN_REJECT_ACCOUNT}
                </BtnSubmitFile>
              )}
            </BtnFileCompanyVerificationWrapper>

            {company?.updated_at && (
              <StatusUpdate>
                {CONST_LIST_AGENCY.LAST_UPDATE} : {formatStrDateTimezone(company.updated_at)} [
                <NameWrapper>{company?.updated_by?.full_name}</NameWrapper>]
              </StatusUpdate>
            )}
          </CompanyCard>
        </Container>
      )}
    </DetailOperatorWrapper>
  );
};
